export default "__VITE_ASSET__MpeENzZR__"